import { Box, Link, Skeleton, Stack } from "@mui/material";
import React from "react";

import { useAccount } from "api/services/useAccount";
import { GROUNDLIGHT_SUPPORT_EMAIL } from "config/constants";
import { useAppSelector } from "hooks/store";
import { Typography } from "new-components/typography/Typography";
import { AccountSectionTitle } from "pages/account/AccountPage";
import { getUserState } from "store/slices/Auth/authSlice";
import { tierMap } from "types/users";

import { AccountInfoData } from "../AccountInfo";

import { DescriptionPlanSection } from "./DescriptionPlanSection";

export function ServicePlan() {
  const { tier, username } = useAppSelector(getUserState);
  const { accountInfo: accountBillingInfo } = useAccount();

  return (
    <Stack sx={{ gap: "10px", backgroundColor: "white", borderRadius: "10px", padding: "10px 20px", height: "100%" }}>
      <AccountSectionTitle text="Service Plan" />
      <AccountInfoData text="Service Type:" />
      <Box
        display="flex"
        justifyContent="center"
        height="30px"
        sx={{ backgroundColor: "#CCEAFF", borderRadius: "5px" }}
      >
        <Typography variant="subtitle" textAlign="center">
          {tierMap[tier]}
        </Typography>
      </Box>
      {!accountBillingInfo ? (
        <Skeleton height="223px" />
      ) : (
        <DescriptionPlanSection planType={tier} accountBillingInfo={accountBillingInfo} />
      )}
      <Link
        href={`mailto:${GROUNDLIGHT_SUPPORT_EMAIL}?subject=Groundlight%20Service%20Plan%20Request%20-%20${username}`}
        sx={{ width: "100%", py: "8px!important", textDecoration: "none" }}
      >
        <Typography
          sx={{
            display: "block",
            fontSize: "12px",
            lineHeight: "14px",
            color: "#006DD9",
            textDecoration: "none",
            fontWeight: "medium",
            textAlign: "center",
          }}
        >
          Contact Groundlight
        </Typography>
      </Link>
    </Stack>
  );
}
